/*** FINAL & PERFECT ADSENSE SYSTEM – WORKS EVEN ON LOCALHOST ***/
import config from './config.js';
import * as utils from './utils.js';

let adsScriptPromise = null;

function ensureAdsScript() {
  if (adsScriptPromise) return adsScriptPromise;

  adsScriptPromise = new Promise((resolve) => {
    if (window.adsbygoogle) return resolve();

    const script = document.createElement("script");
    script.src = "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-4009330668502369";
    script.async = true;
    script.crossOrigin = "anonymous";
    script.onload = () => resolve();
    script.onerror = () => resolve();
    document.head.appendChild(script);
  });

  return adsScriptPromise;
}

export function fillAdsenceContainers(pagetype) {
  loadAdsPerPageType(pagetype);
}

function loadAdsPerPageType(pagetype) {
  if (pagetype === "index" || pagetype === "home" || pagetype === "category" || pagetype === "history") {
    createGoogleAds("4443897647", "ads-top-banner", true, "display:inline-block;min-width:320px;");
    setTimeout(() => createGoogleAds("2506237002", "ads-header", true, "display:block;", "auto"), 2000);
    // setTimeout(() => createGoogleAds("4511120910", "ads-images", false, "display:block;", "fluid", "", "-bm-15+52+an-z5"), 4000);
    setTimeout(() => createGoogleAds("9767039104", "ads-bottom", true, "display:block;", "auto"), 3000);
  }
  if (pagetype === "download") {
    createGoogleAds("4443897647", "ads-top-banner", true, "display:inline-block;min-width:320px;");
    setTimeout(() => createGoogleAds("2506237002", "ads-header", true, "display:block;", "auto"), 2000);
    setTimeout(() => createGoogleAds("9767039104", "ads-bottom", true, "display:block;", "auto"), 3000);
  }
}
async function createGoogleAds(adslot, classname, responsive = true, style = "display:block", data_adFormat = "auto") {
  const parents = document.getElementsByClassName(classname);
  if (!parents.length) return;

  await ensureAdsScript();

  for (const parent of parents) {
    if (parent.querySelector("ins.adsbygoogle")) continue;

    const ins = document.createElement("ins");
    ins.className = "adsbygoogle";
    ins.style.display = "block";
    ins.setAttribute("data-ad-client", "ca-pub-4009330668502369");
    ins.setAttribute("data-ad-slot", adslot);
    ins.setAttribute("data-ad-format", "auto");
    ins.setAttribute("data-full-width-responsive", "true");

    parent.appendChild(ins);

    try {
      (adsbygoogle = window.adsbygoogle || []).push({});
    } catch (e) {
      console.error(e);
    }
  }
}

// async function createGoogleAds(adslot, classname, responsive = true, style = "display:block", data_adFormat = "auto") {
//   const parents = document.getElementsByClassName(classname);
//   if (!parents.length) return;

//   for (const parent of parents) {
//     if (parent.querySelector("ins.adsbygoogle")) continue;

//     // إعداد الحاوية - ضروري جداً لظهور اليدوي
//     parent.classList.add("adsense-lazy-container");
//     parent.style.minHeight = "250px"; // حجز مساحة كافية للـ Observer
//     parent.style.display = "block";

//     const ins = document.createElement("ins");
//     ins.className = "adsbygoogle";
//     // تأكد أن الـ style يحتوي على أبعاد واضحة
//     ins.setAttribute("style", style + "; min-width:250px; min-height:90px;");
//     ins.setAttribute("data-ad-client", "ca-pub-4009330668502369");
//     ins.setAttribute("data-ad-slot", adslot);

//     if (responsive) ins.setAttribute("data-full-width-responsive", "true");
//     if (data_adFormat) ins.setAttribute("data-ad-format", data_adFormat);

//     parent.appendChild(ins);
//     lazyLoadAdWhenVisible(ins, parent);
//   }
// }

function lazyLoadAdWhenVisible(adElement, container) {
  const observer = new IntersectionObserver(async (entries) => {
    if (!entries[0].isIntersecting) return;

    await ensureAdsScript();


    try {
      (adsbygoogle = window.adsbygoogle || []).push({});
    } catch (e) { }


    waitForAdFinalResult(adElement, container);

    observer.unobserve(adElement);
  }, { rootMargin: "500px", threshold: 0.01 });

  observer.observe(adElement);
}

function smoothCollapseContainer(container) {
  // نحصل على الارتفاع الحالي قبل الحذف لتجنب القفزة المفاجئة
  const currentHeight = container.offsetHeight;
  container.style.maxHeight = currentHeight + "px";

  // ننتظر "تيك" واحدة من المتصفح لضمان تفعيل الـ transition
  requestAnimationFrame(() => {
    container.classList.add("ad-collapsing");
  });

  // حذف العنصر تماماً من الـ DOM بعد انتهاء الانيميشن لتحسين الأداء
  setTimeout(() => {
    container.style.display = "none";
  }, 1000); // تقليل الوقت ليتناسب مع الـ CSS transition
}
function waitForAdFinalResult(adElement, container) {
  let settled = false;

  const finish = (isEmpty = true) => {
    if (settled) return;
    settled = true;

    if (isEmpty) {
      // smoothCollapseContainer(container);
      // adElement.style.opacity = "0";
      // container.classList.add("ad-empty");
    } else {
      // إعلان ناجح
      container.classList.remove("ad-empty", "ad-collapsing");
      container.classList.add("ad-loaded");
      container.style.maxHeight = "none";
      container.style.display = "block";
      adElement.style.opacity = "1";
    }
  };

  const statusCheck = setInterval(() => {
    const status = adElement.getAttribute("data-ad-status");
    const googleStatus = adElement.getAttribute("data-adsbygoogle-status");
    const iframe = adElement.querySelector("iframe");

    // حالة النجاح: وجود آيفريم وله ارتفاع حقيقي
    if (iframe && iframe.offsetHeight > 10) {
      clearInterval(statusCheck);
      clearTimeout(timeout);
      finish(false);
    }
    // حالة الفشل المؤكدة: جوجل قال بوضوح لا يوجد إعلان
    else if (status === "unfilled") {
      clearInterval(statusCheck);
      clearTimeout(timeout);
      finish(true);
    }
    // حالة الانتظار: لو جوجل خلص (done) بس لسه مفيش آيفريم ولا unfilled، بنستنى الـ timeout
  }, 200);

  const timeout = setTimeout(() => {
    clearInterval(statusCheck);
    // لو خلص الوقت وما ظهرش إعلان، نعتبره فارغ
    if (!settled) finish(true);
  }, 30000); // 5 ثواني كافية جداً
}
